module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Warlord’s Bride")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("CHAPTER ONE")])])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterDateline"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Wales, 1205")])])])]), _c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_c('span', [_vm._v("L"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("ORD")])]), _vm._v(" A"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("LFRED DE")])]), _vm._v(" G"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("ARLEBOINE")])])])]), _vm._v(" drew his dappled palfrey to a halt and peered through the water dripping from his coif. More rain fell from the pine trees beside the road and roused their heavy scent, while the verge was a mess of mud and running water. The drizzle rendered the sky a leaden gray and the rest of the landscape all mucky brown and dull green, the few exposed rocks like hunched little men trying to keep dry.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“God be praised, Llanpowell at last,” the middle-aged nobleman muttered as his mount refooted, its hooves churning up mud and pebbles.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("From under the sodden hood of her cloak lined with fox fur, the young lady riding beside him followed his gaze to what was most definitely a castle and not just another stony outcropping in the south of Wales.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“My lord!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("At the alarmed cry, Lord Alfred and Lady Roslynn de Werre looked back to see a heavy wooden cart stuck in a rut and tilting precariously. The toothless carter leaned to one side, whipping the pair of draft horses and exhorting them to move. The horses snorted and pulled against the harness, but the wheel only sank deeper into the mud.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Don’t just sit there like a lump of dung,” Lord Alfred ordered. “Get off and make those stupid beasts move!” He pointed at six of the soldiers in the escort. “Stay with the wagon until it’s at the castle. The rest of us will continue.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He shifted forward, then turned his steely, gray-eyed gaze onto Lady Roslynn. “Do you have any objection to leaving the wagon and going on to the castle, my lady?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You are in command here,” she said with a beatific smile quite at odds with her internal turmoil. In truth, she would rather sit in a downpour than reach Llanpowell. “Are six men really necessary to guard the wagon when we’re so close to a nobleman’s castle, and in such inclement weather?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’ll not take any chances,” Lord Alfred replied before raising his hand and shouting for the rest of the cortege to move on.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lady Roslynn suppressed a sigh. She didn’t know why King John’s courtier had even bothered to ask her opinion. No doubt she shouldn’t have bothered to answer.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The cortege continued on its way, the silence broken only by the falling rain, the jingle of accoutrements and soldiers’ chain mail, and the slap of hooves on the muddy road, every step bringing them closer to the castle of the lord of Llanpowell. Like the rocks, it seemed to be a natural feature of the landscape, exposed by time and the weather, not an edifice built by men.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("This entire land was a rough contrast to Roslynn’s familiar Lincolnshire, where the flat fens stretched out for miles and the sky seemed endless. Here, there were hills and valleys, unexpected streams and wet bracken, scree and rocks. It was wild and untamed, strange and breathtaking, despite the presence of the colossal fortress looming ahead.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Roslynn tried to stifle her dread as they neared the massive, bossed gates of thick oak. Whatever happened here, at least she was away from the king’s court, and the accommodations should be better than those they’d had along the way.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A voice called out from the top of the barbican, speaking Norman French, albeit with a noticeable Welsh accent. “Who are you and what do you want at Llanpowell?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I am Lord Alfred de Garleboine, on the king’s business,” the nobleman shouted back.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“The king’s business?” the man on the wall walk repeated. “Which one?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Is the man a simpleton?” Lord Alfred muttered. He raised his voice. “John, by the grace of God, king of England, lord of Ireland, duke of Normandy and Aquitaine, count of Anjou.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Oh, the Plantagenet usurper who killed his nephew.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Although the man on the wall had said only what many believed was true, this didn’t bode well for a pleasant reception.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Three others, likewise bareheaded and wearing tunics, not chain mail, joined the man on the wall.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What does John want?” one of them called out.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I will discuss that with your overlord,” Lord Alfred replied.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Maybe you’ve come to attack,” the first man called back.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lord Alfred shifted impatiently in his ornately gilded saddle. “Do we look like a band of brigands?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Can’t be too sure these days,” the first man replied, apparently quite unconcerned by the nobleman’s growing impatience. “Seen some well-dressed Norman thieves in our time, we Welsh have.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Open these gates or the king shall hear of this, as well as your master!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("It seemed that while the sentries were content to make sport of Norman visitors and their king, the lord of Llanpowell was not likely to be amused by their insolence, for the massive gates slowly began to open.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("What did that say about the lord of Llanpowell? That he ruled by fear and harsh punishment? Or was he simply not to be trifled with, but respected and obeyed?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Whatever Madoc ap Gruffydd was like, there was no turning back or running away now.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“About bloody time. Insolent savages,” Lord Alfred growled as he flicked his gauntleted hand and gestured for their party to enter the castle.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Inside the outer wall was a large area, grassy and perhaps fifty yards long. Beyond the outer ward was the inner curtain wall, taller than the first, with another gate and a less elaborate gatehouse.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The inner gates were open, and a large wooden cart pulled by two thick-chested oxen rumbled toward them, followed by a group of twenty men, all wearing sword belts, with bows in their hands and quivers at their hips. They wore only leather tunics, breeches and boots, however, not chain mail or helmets. Their hair was almost uniformly dark brown or black, and most sported thick beards.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Despite their attire, they must be part of the garrison, for they briskly formed two rows lining the road leading through the studded gate to the inner ward.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lord Alfred’s jaw clenched. “The king shall hear of this insult, as well.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I believe it’s a guard of honor, my lord,” Roslynn quietly offered. “See how they’re arranged and how still they stand?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lord Alfred’s only response to her observation was a noncommittal grunt.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nevertheless, she was sure she was right, for the men remained where they were, staring stoically ahead, as the cortege continued into the courtyard.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Here the buildings were of several sizes and materials. Some were made of stone, with slate roofs. Others, like the stables, were half-timbered and wattle-and-daub, and some looked like little more than wooden lean-tos attached to any available wall. At least the yard was cobblestoned, so while there were several large and growing puddles, it was not a sea of mud.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Unfortunately, there were also several armed soldiers around the perimeter, standing beneath the eaves of buildings and watching them warily.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Before they could dismount, or a groom or stable boy arrived to take the horses, the door to the largest of the stone buildings flew open as if caught by a strong wind. A rotund, gray-haired fellow clad in a dusky green tunic, plain breeches and scuffed boots, with a dark brown woolen cloak thrown about his shoulders, came hurrying down the steps. Like the others, his hair was long and his beard full. Unlike the others, he wore only a simple belt, with no obvious weapon at his side, and a smile lit his round face. He also carried a huge mug in his hands, despite the continuing rain.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Welcome, my lord, my lady!” he called out in Welsh-tinged French, ignoring the puddles as he splashed his way toward them. “Welcome to Llanpowell! Welcome to my home. An honor it is to have you here!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("It felt as if a stone had settled into Roslynn’s stomach as she realized this must be Madoc ap Gruffydd, the lord of Llanpowell.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She had—foolishly, it now seemed—assumed the Bear of Brecon would be a younger man. She’d also assumed he was called the Bear because of his fierceness in battle, not for wild gray hair that fell to his shoulders, his bushy beard or the size of his belly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Or perhaps that name had been given to him in his youth.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The Welshman called out a few orders in his native tongue, and immediately grooms and boys appeared from the stables to take hold of their horses.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Apparently the lord of Llanpowell’s servants were as well trained as his soldiers, in spite of his jovial appearance and friendly manner.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Come inside and get dry!” the Welshman cried as he waved his hand toward the large stone building that must be the hall, paying no heed to the drink that spilled from his mug.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Roslynn sincerely hoped Madoc ap Gruffydd wasn’t a drunkard.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His expression grim, Lord Alfred swung down from his saddle and came to help her dismount. Once on the ground, she took a deep breath and shook out the full gored skirt of her gown of perse, while Lord Alfred stiffly held out his arm to lead her into the hall behind their host.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The soldiers in the yard remained where they were, watchful and suspicious.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The hall was rather small, and close, and old, the beams dark with age and smoke. Unlike more recently built halls, it had a central hearth and the roof was held up not by pillars of stone, but wood, some plain, some carved with vines and leaves and faces of animals. Rushes covered the floor, and three large hunting dogs, as shaggy as their master, lumbered to their feet, sniffing at the Normans as they passed. Several servants waited by the walls, watching like the soldiers in the yard, as their host led them toward the hearth and the benches and single wooden chair arranged around it.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("After seeing the castle’s fortifications, Roslynn had assumed that the living quarters of Llanpowell would be more modern and comfortable. It was disappointing to discover they were not, but at least they would be dry.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("And no matter how primitive the accommodations, this was still better than being at King John’s court, where she had to fend off the advances of the king and every other lascivious courtier who believed, given her recent history, that she should be grateful for his attention.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Sit you down by the fire, my lady,” their host said as he threw off his cloak, goblet still in hand. He didn’t seem to notice or care that his cloak fell to the rush-covered floor before a servant had time to grab it.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Bron, what are you about, girl?” he demanded of another maidservant standing by the wall, who looked about eighteen years old. “Take her ladyship’s cloak.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The young woman darted forward and waited while Roslynn removed the rain-soaked garment. The servant, just as quickly, hurried to hang it on a peg on the wall before returning to her post.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("It was warmer near the fire, and Roslynn was well dressed in a thick woolen gown and heavy boots, but she shivered nonetheless and wrapped her arms about herself as she took a seat on the bench.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Smiling expansively, the Welshman settled his bulk in the chair and grinned at Lord Alfred, who stood so stiffly, one might conclude he was incapable of bending at the waist.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No doubt you’re wondering what has brought us here,” he began just as stiffly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Aye, I do, but sit down, man!” the Welsh nobleman commanded with a deep chuckle. “Drink and food before business. Can’t think of important matters when my belly rumbles. Bron, some mulled wine for our guests, and barley bread and the soft cheese, not the hard. No "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("braggot.")])]), _vm._v(" Not yet, anyway.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As the young woman disappeared into what was likely the corridor to the kitchen, the Welshman turned to Roslynn with a wink. “"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Braggot’")])]), _vm._v("s Welsh mead, my lady, and strong, so we best stay with the wine for now.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She managed to return his smile. Madoc ap Gruffydd was neither young nor handsome, but that was surely all to the good. Had she not learned how deceptive youth and a comely face and form could be? Besides, a man of his age could well be past greed and ambition, happy to live out his days in quiet contentment on his estate. That could explain why Madoc ap Gruffydd was so cheerful and welcoming: he had no reason not to be.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“So, my lord, how does the king fare these days?” he inquired as he tossed his now-empty goblet at another of the servants, who caught it so deftly, she assumed this happened often. “Still happy with his little French wife?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“King John is quite well and, yes, happily wed. We have every hope an heir to the throne will soon be forthcoming,” Lord Alfred coldly replied. “Now, if you will permit me to introduce myself, my lord. I am Lord Alfred de Garleboine and this is—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Lord Alfred de Garleboine? There’s a mouthful. Can’t say I’ve heard of you, but then, I don’t pay much attention to the English court and the mischief they get up to.” The Welshman patted Roslynn’s hand. “Much more pleasant to tell stories round the fire and sing songs of brave deeds, eh, my lady?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“A nobleman must pay heed to what transpires at court if he is to assist the king and protect his family,” she replied, not impressed by his apparently lackadaisical attitude, especially in such times, and with such a king upon the throne.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Oh, I know enough, I know enough. Not quite at the end of the world, us,” Lord Madoc replied, before raising his voice to shout for Bron. She immediately reappeared in the doorway, a distinctly harried expression on her pretty face. “Where’s the food, girl? And the drink? Our guests are starving! Fine thing if they can’t get a bite to eat after riding in the wet!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The maidservant said something in rapid Welsh, then disappeared again.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“It’s not that we don’t have plenty in the larder, my lady,” the lord of Llanpowell explained as if it was a matter of grave concern. “It’s just you caught us between meals while we wait for the patrols to come back. Had a bit of bother with them over the mountain.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As Roslynn smiled to show him she wasn’t disturbed by the delay, she wondered what he meant by “bit of bother” and who “them over the mountain” might be. Enemies, clearly, but how many and how powerful? She’d been told almost nothing about the lord of Llanpowell and even less about any potential enemies he might have.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“My lord,” Lord Alfred began again, his exasperation obvious. “We have come—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Ah, here’s the food now!” the Welshman interrupted as the serving girl arrived carrying a large tray bearing three unexpectedly fine silver goblets, a carafe of steaming wine, whose spicy scent filled the air and a beechwood platter covered with a napkin. One of the other male servants hurried forward with a small bench, which he put in front of Madoc ap Gruffydd. After Bron set the tray on it, the Welshman whisked off the napkin to reveal two sliced loaves of fresh, brown bread and several slices of thick cheese, as well as honey cakes.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As the aroma from the warm bread and spiced wine filled her nostrils, Roslynn’s stomach growled loudly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She blushed with embarrassment, but the lord of Llanpowell laughed and handed her one of the goblets before pouring her some wine. “What did I tell you? Hungry you are, and no mistake. I could see that by the look of you, and a little more flesh on your bones might not be amiss.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Perhaps "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("now")])]), _vm._v(" we could discuss the purpose of our visit,” Lord Alfred said through clenched teeth.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The Welshman’s merry expression disappeared in an instant, replaced by cold disapproval. “You may have come from the Plantagenet king, my lord, and with no invitation I’m aware of, but it’s hospitality first in this household, business after.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lord Alfred’s narrow face reddened before he finally, slowly, sat down across the fire from Roslynn and accepted a goblet of mulled wine.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“There now, eat and talk after,” the Welshman said, his anger disappearing as swiftly as the steam from the carafe.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The wine was surprisingly good and did indeed warm her. In spite of its taste and comforting effect, however, she was careful not to drink too much. She didn’t want anything clouding her ability to think.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Isn’t that better?” the Welshman said after the platters were nearly empty and Roslynn couldn’t eat another bite. “And now to business. So, Lord Alfred de Garleboine, what brings you and your lovely daughter to Llanpowell?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Roslynn nearly spit out her wine, although it was an innocent mistake. Lord Alfred "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("was")])]), _vm._v(" old enough to be her father.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Lady Roslynn is not my daughter,” Lord Alfred sternly replied. “She is—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Your pretty wife then, is it?” the Welshman cried, grinning. “What a fortunate fellow you are!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lord Alfred couldn’t look more appalled, while Roslynn felt the most unexpected urge to giggle, despite her circumstances. “No, she most certainly is not my wife. She is—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Saints preserve us,” Lord Madoc cried as if torn between scandal and admiration, “you don’t mean to say she’s your lehman?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No!” Roslynn gasped, breaking into the conversation. “I am "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("not")])]), _vm._v(" his mistress!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Well, thanks be to heaven for that,” the Welshman said with genuine relief as Lord Alfred’s face went from red to purple, “or I’d be thinking you were lacking in taste.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“My lord,” Lord Alfred ground out, “Lady Roslynn is here at the behest of King John.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“He has women ambassadors now, does he?” the Welshman replied with amazement, not the least upset by Lord Alfred’s anger and addressing Roslynn instead of the Norman. “Interesting, I must say, and clever, too. I’ll gladly listen to anything a beautiful woman has to say.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“If you will allow me to explain, my lord,” Lord Alfred said, his hands gripping the stem of his goblet as if he were wringing a chicken’s neck, “Lady Roslynn de Werre has recently been widowed—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Oh, there’s a pity,” Lord Madoc exclaimed, regarding her with sympathy as he patted her arm again. “So young, too.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Widowed,” Lord Alfred forcefully continued, “and the king has—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The door to the hall banged open and a tall, clean-shaven young man with dark hair to his broad shoulders strode into the room.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He was dressed like the other men in a plain leather tunic over a light shirt that laced at the neck, with woolen breeches tucked into scuffed leather boots. Unlike Lord Madoc, he wore a swordbelt, old and supple, and the hilt of the weapon in the sheath was of iron wrapped in leather strips darkened with age and wear.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Also unlike Lord Madoc, he was unexpectedly, astonishingly handsome. Curling dark hair framed a face of sharp planes and strong angles. A wide forehead and brown brows overshadowed equally dark eyes that seemed to glow with inner light. His nose was straight and narrow above full, well-cut lips.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As he returned her scrutiny, she began to tremble. Yet it was not from fear or lust, but from the sudden certainty that he could see her beating heart thudding with dread.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She was just as surprised to realize, from the wrinkle that formed between those penetrating eyes, that he was not pleased that it was so.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The lord of Llanpowell hoisted himself to his feet and hurried forward to meet the man, mercifully taking his disconcerting attention away from her. They conversed in rapid Welsh, the older man seemingly trying to placate the younger.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Their stances similar, they could be relatives. Father and son, perhaps?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She hadn’t been informed that the lord of Llanpowell had been married before, or had a son or other children, but then, she’d been told almost nothing about Madoc ap Gruffydd. All John had told her was that the Bear of Brecon was to be rewarded with a wife and rich dowry for helping to end her late husband’s rebellious schemes, and she was to be the bride.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("What if he was his son? A grown son made a second wife’s position much more precarious—if she were to marry the lord of Llanpowell.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“We’re being rude,” the older man suddenly declared in Norman French, turning toward his guests. “Come and meet our visitors.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lord Alfred was already on his feet, and Roslynn slowly joined him, sliding her hands into the long cuffs of her gown and gripping her forearms to still their trembling as they approached.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“This is Lord Alfred de Garleboine come from King John,” the older man said, “and this is Lady Roslynn. Not his daughter or wife or anything else to him, apparently, and recently widowed, poor thing.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The young man planted his feet and crossed his arms as he regarded her warily.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He didn’t mask his feelings, his thoughts or his reactions, as so many did. Because he didn’t have to? Because he had the power and confidence to reveal exactly what he thought and felt, to everyone?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Power and confidence—yes, he fairly exuded those qualities. His manner made Lord Alfred seem a model of gentle courtesy, and his father hospitality personified.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As quickly as the heat of desire had rushed over her at that first glance, it died. He wasn’t some untamed warrior prince to be admired and desired, but an arrogant, powerful man who might do her harm.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She had vowed that she would never again allow a man to hurt her, whatever King John ordered.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her determination and pride roused, she raised her chin and met his suspicious scrutiny steadily. “I am Lady Roslynn de Werre.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“De Werre?” the younger man repeated, his eyes narrowing. “Like the traitor?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yes. I was Wimarc de Werre’s wife, and since the king is grateful for your father’s recent—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“My father?” the younger Welshman interrupted. “My father’s been dead these past three years.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Roslynn’s startled gaze flew from the younger man to the older one behind him and back again. “Isn’t your father Lord Madoc ap Gruffydd?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No,” the young man replied. “"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("I")])]), _vm._v(" am the lord of Llanpowell.”")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d6d2c32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/warlordsbridethe_ch01.vue
// module id = 78
// module chunks = 0